export const URLS = {
  PRIVACY_POLICY: 'https://datahive.ai/policy?external',
  TERMS_CONDITIONS: 'https://datahive.ai/terms?external',
  EXTENSION_INSTALL: 'https://chromewebstore.google.com/detail/datahive/bonfdkhbkkdoipfojcnimjagphdnfedb',
  BLOG_STAKING: 'https://datahive.ai/blog/2026/02/26/stake-sol-earn-aidrop/',
  BLOG_REFERRAL_PROGRAM: 'https://datahive.ai/blog/2025/12/08/datahive-ai-referral-program/',
  ANDROID_APP: (inviteCode?: string) =>
    `https://play.google.com/store/apps/details?id=acl.datahive.app${inviteCode ? `&referrer=${encodeURIComponent(`invitationCode=${inviteCode}`)}` : ''}`
}
